const mutations = {
    setCurrentUser(state, user) {
        state.currentUser = user
    },
    setLoggedInUser(state, user) {
        state.loggedInUser = user
    },
    setLastVisitedSlug(state, slug) {
        state.lastVisitedSlug = slug
    },
    setLanguagePreference(state, language) {
        state.preferences.language = language
    },
    setThemePreference(state, theme) {
        state.preferences.theme = theme
    },
    setSchemePreference(state, scheme) {
        state.preferences.scheme = scheme
    },
    setTimelinePreference(state, timeline) {
        state.preferences.timeline = timeline
    },
    setOrderPreference(state, order) {
        state.preferences.order = order
    },
    setCookiePreference(state, preference) {
        state.preferences.cookies = preference
    },
    setSensitivePreference(state, preference) {
        state.preferences.showSensitive = preference
    },
    setUserListDialog(state, dialog) {
        state.userListDialog = dialog
    }
}

export default mutations